"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FailedRulesSummary = exports.BulkApplyPanel = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _importedBottomSheet = require("@common/components/chat-composer/sheets/imported-bottom-sheet");
var _materialSymbols = require("@design/icons/material-symbols");
var _spinner = require("@design/ui/spinner");
var _BulkApplyRunContext = require("../../context/BulkApplyRunContext");
var _BulkApplyFailedRules = require("./BulkApplyFailedRules");
var _WordSlowResponseNotice = require("../common/WordSlowResponseNotice");
var _WordWriteLockNotice = require("../common/WordWriteLockNotice");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var STEP_STATUS_ICONS = {
  QUEUED: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ScheduleIcon, {}),
  IN_PROGRESS: /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {}),
  COMPLETED: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckCircleIcon, {}),
  FAILED: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CancelIcon, {})
};
var StepsList = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 12px 0;\n"])));
var StepItem = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: #FAFAF9;\n  border: 1px solid #E5E2DD;\n  border-radius: 6px;\n  transition: all 150ms ease;\n"])));
var StepIcon = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n\n  ", "\n"])), function (props) {
  switch (props.status) {
    case 'IN_PROGRESS':
      return "color: var(--muted-foreground);";
    case 'COMPLETED':
      return "color: #10B981;";
    case 'FAILED':
      return "color: #EF4444;";
    default:
      return "color: #9CA3AF;";
  }
});
var StepContent = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
var StepTitle = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 1px;\n"])));
var StepDescription = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  color: #6B7280;\n"])));
var TONE_COLORS = {
  running: 'var(--muted-foreground)',
  done: '#0F9268',
  partial: '#B45309',
  failed: '#DC2626'
};
var ApplyBar = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  height: 34px;\n  margin-bottom: 8px;\n  padding: 0 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13.5px;\n  color: #111827;\n  background: #FFFFFF;\n  border: 1px solid #E5E2DD;\n  border-left: 3px solid ", ";\n  border-radius: 6px;\n"])), function (props) {
  return TONE_COLORS[props.tone];
});
var ApplyGlyph = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  width: 14px;\n  height: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n\n  svg {\n    width: 14px;\n    height: 14px;\n  }\n"])), function (props) {
  return TONE_COLORS[props.tone];
});
var ApplyLabel = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  flex: 1;\n  min-width: 0;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var ApplyCount = _styledComponents.default.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n  color: #6B7280;\n"])));
var ApplyTrack = _styledComponents.default.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 3px;\n  background: ", ";\n  opacity: 0.2;\n"])), function (props) {
  return TONE_COLORS[props.tone];
});
var ApplyTrackFill = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  height: 100%;\n  background: ", ";\n  transition: width 200ms ease;\n"])), function (props) {
  return TONE_COLORS[props.tone];
});
var FailedRulesBanner = _styledComponents.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  color: #a16207;\n  background-color: #fffbeb;\n  border: 1px solid var(--warning-border);\n  border-radius: 6px;\n  padding: 8px;\n  margin-bottom: 8px;\n  font-size: 14px;\n  display: flex;\n  gap: 6px;\n"])));
var StackedFailedRulesBanner = (0, _styledComponents.default)(FailedRulesBanner)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  flex-direction: column;\n"])));
var FailedRulesHeading = _styledComponents.default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n"])));
var FailedRulesSummary = exports.FailedRulesSummary = function FailedRulesSummary(_ref) {
  var failedRules = _ref.failedRules,
    failedCardDetails = _ref.failedCardDetails,
    onShowRule = _ref.onShowRule,
    _ref$proposalLayout = _ref.proposalLayout,
    proposalLayout = _ref$proposalLayout === void 0 ? false : _ref$proposalLayout;
  if (proposalLayout) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StackedFailedRulesBanner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(FailedRulesHeading, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
          width: 15,
          height: 15
        }), "Some rules didn't apply."]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BulkApplyFailedRules.BulkApplyFailedRules, {
        failedRules: failedRules,
        details: failedCardDetails,
        onShowRule: onShowRule
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(FailedRulesBanner, {
    "data-sentry-element": "FailedRulesBanner",
    "data-sentry-component": "FailedRulesSummary",
    "data-sentry-source-file": "BulkApplyPanel.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: "\u26A0\uFE0F"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        flex: 1,
        minWidth: 0
      },
      children: ["Some rules didn't apply.", /*#__PURE__*/(0, _jsxRuntime.jsx)(_BulkApplyFailedRules.BulkApplyFailedRules, {
        failedRules: failedRules,
        details: failedCardDetails,
        onShowRule: onShowRule,
        "data-sentry-element": "BulkApplyFailedRules",
        "data-sentry-source-file": "BulkApplyPanel.tsx"
      })]
    })]
  });
};

/**
 * The progress view of the one bulk apply run, mounted once at the app root and
 * driven entirely by `BulkApplyRunContext`: it owns no run state, so the run
 * outlives any re-render of the chat message, drawer or page that started it.
 */
var BulkApplyPanel = exports.BulkApplyPanel = function BulkApplyPanel() {
  var _useBulkApplyRun = (0, _BulkApplyRunContext.useBulkApplyRun)(),
    isPanelOpen = _useBulkApplyRun.isPanelOpen,
    closePanel = _useBulkApplyRun.closePanel,
    steps = _useBulkApplyRun.steps,
    applyBar = _useBulkApplyRun.applyBar,
    failedRules = _useBulkApplyRun.failedRules,
    failedCardDetails = _useBulkApplyRun.failedCardDetails,
    runKind = _useBulkApplyRun.runKind,
    request = _useBulkApplyRun.request;
  var showRule = request === null || request === void 0 ? void 0 : request.onShowRule;
  var onShowRule = showRule === undefined ? undefined : function (ruleId) {
    void closePanel();
    showRule(ruleId);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_importedBottomSheet.BottomSheet, {
    open: isPanelOpen,
    title: "Bulk apply progress",
    onClose: function onClose() {
      return void closePanel();
    },
    onEscapeKeyDown: function onEscapeKeyDown(event) {
      return event.preventDefault();
    },
    "data-sentry-element": "BottomSheet",
    "data-sentry-component": "BulkApplyPanel",
    "data-sentry-source-file": "BulkApplyPanel.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(ApplyBar, {
        tone: applyBar.tone,
        "data-sentry-element": "ApplyBar",
        "data-sentry-source-file": "BulkApplyPanel.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(ApplyGlyph, {
          tone: applyBar.tone,
          "data-sentry-element": "ApplyGlyph",
          "data-sentry-source-file": "BulkApplyPanel.tsx",
          children: [applyBar.tone === 'running' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {}), applyBar.tone === 'done' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckCircleIcon, {}), applyBar.tone === 'partial' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {}), applyBar.tone === 'failed' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CancelIcon, {})]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ApplyLabel, {
          "data-sentry-element": "ApplyLabel",
          "data-sentry-source-file": "BulkApplyPanel.tsx",
          children: applyBar.label
        }), applyBar.count && /*#__PURE__*/(0, _jsxRuntime.jsx)(ApplyCount, {
          children: applyBar.count
        }), applyBar.percent !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)(ApplyTrack, {
          tone: applyBar.tone,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ApplyTrackFill, {
            tone: applyBar.tone,
            style: {
              width: "".concat(applyBar.percent, "%")
            }
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_WordWriteLockNotice.WordWriteLockNotice, {
        "data-sentry-element": "WordWriteLockNotice",
        "data-sentry-source-file": "BulkApplyPanel.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_WordSlowResponseNotice.WordSlowResponseNotice, {
        surface: "apply_all",
        "data-sentry-element": "WordSlowResponseNotice",
        "data-sentry-source-file": "BulkApplyPanel.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StepsList, {
        "data-sentry-element": "StepsList",
        "data-sentry-source-file": "BulkApplyPanel.tsx",
        children: steps.map(function (step) {
          var _step$details;
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StepItem, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StepIcon, {
              status: step.status,
              children: STEP_STATUS_ICONS[step.status]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StepContent, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StepTitle, {
                children: step.title
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StepDescription, {
                children: (_step$details = step.details) !== null && _step$details !== void 0 ? _step$details : step.description
              })]
            })]
          }, step.key);
        })
      }), failedRules.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(FailedRulesSummary, {
        failedRules: failedRules,
        failedCardDetails: failedCardDetails,
        onShowRule: onShowRule,
        proposalLayout: runKind === "local"
      }), runKind === null && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px 12px',
          color: '#6B7280'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {
          className: "mr-1.5"
        }), "Starting..."]
      })]
    })
  });
};